import { render } from "./HeroiconsOutlineLocationMarker.vue?vue&type=template&id=6e027f2a"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineLocationMarker.vue"]])

export default __exports__